(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelectorAll('.menu-toggler').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelector('.header').classList.toggle('active');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upselling-compare-treatments-intrabucal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.addToCartMultipleCompare').forEach(button => {
    button.addEventListener('click', async () => {
      const mainId = button.dataset.mainVariantId;
      const extraId = button.dataset.extraVariantId;
      const extraSellingPlan = button.dataset.extraSellingPlanId;
      const el = document.getElementById('my-section');
      const sellingPlanId = button.dataset.sellingPlanId;


      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              items: [
                {
                  id: mainId,
                  quantity: 1,
                  selling_plan: sellingPlanId
                }, {
                  id: extraId,
                  quantity: 1,
                  selling_plan: extraSellingPlan
                }
              ]
            }
          )
        });

        const data = await response.json();

        if (! response.ok) {
          console.error('Cart error:', data);
          return;
        }

        window.CartDrawer.updateCartDrawer();
        const res = await fetch("/cart.js");
        const cart = await res.json();
        window.CartDrawer.updateCartItemCounts(cart.item_count);
        document.querySelector(".cart-drawer").classList.add("cart-drawer--active");

      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    });
  });

  document.querySelectorAll('.addToCartCompare').forEach(button => {
    button.addEventListener('click', async () => {
      const mainId = button.dataset.mainVariantId;
      const sellingPlanId = button.dataset.sellingPlanId;


      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              items: [
                {
                  id: mainId,
                  quantity: 1,
                  selling_plan: sellingPlanId
                }
              ]
            }
          )
        });

        const data = await response.json();

        if (! response.ok) {
          console.error('Cart error:', data);
          return;
        }

        window.CartDrawer.updateCartDrawer();
        const res = await fetch("/cart.js");
        const cart = await res.json();
        window.CartDrawer.updateCartItemCounts(cart.item_count);
        document.querySelector(".cart-drawer").classList.add("cart-drawer--active");

      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upselling-compare-treatments"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.addToCartMultipleCompare').forEach(button => {
    button.addEventListener('click', async () => {
      const mainId = button.dataset.mainVariantId;
      const extraId = button.dataset.extraVariantId;
      const extraSellingPlan = button.dataset.extraSellingPlanId;
      const el = document.getElementById('upsellingCompare-simpleButton');
      const sellingPlanId = button.dataset.sellingPlanId;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              items: [
                {
                  id: mainId,
                  quantity: 1,
                  selling_plan: sellingPlanId

                }, {
                  id: extraId,
                  quantity: 1,
                  selling_plan: extraSellingPlan
                }
              ]
            }
          )
        });

        const data = await response.json();

        if (! response.ok) {
          console.error('Cart error:', data);
          return;
        }

        window.CartDrawer.updateCartDrawer();
        const res = await fetch("/cart.js");
        const cart = await res.json();
        window.CartDrawer.updateCartItemCounts(cart.item_count);
        document.querySelector(".cart-drawer").classList.add("cart-drawer--active");

      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    });
  });

  document.querySelectorAll('.addToCartCompare').forEach(button => {
    button.addEventListener('click', async () => {
      const mainId = button.dataset.mainVariantId;
      const el = document.getElementById('upsellingCompare-simpleButton');
      const sellingPlanId = button.dataset.sellingPlanId;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              items: [
                {
                  id: mainId,
                  quantity: 1,
                  selling_plan: sellingPlanId
                }
              ]
            }
          )
        });

        const data = await response.json();

        if (! response.ok) {
          console.error('Cart error:', data);
          return;
        }

        window.CartDrawer.updateCartDrawer();
        const res = await fetch("/cart.js");
        const cart = await res.json();
        window.CartDrawer.updateCartItemCounts(cart.item_count);
        document.querySelector(".cart-drawer").classList.add("cart-drawer--active");

      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-main-custom"]) return;
  try {
    
  // Create sentinels
  const topSentinel = document.createElement('div');
  const bottomSentinel = document.createElement('div');

  topSentinel.style.position = 'absolute';
  topSentinel.style.top = '100vh';
  topSentinel.style.height = '1px';

  bottomSentinel.style.position = 'absolute';
  bottomSentinel.style.height = '1px';
  bottomSentinel.style.width = '1px';

  const positionBottomSentinel = () => {
    bottomSentinel.style.top = `${
      document.documentElement.scrollHeight - window.innerHeight
    }px`;
  };

  positionBottomSentinel();

  const resizeObserver = new ResizeObserver(() => {
    positionBottomSentinel();
  });

  resizeObserver.observe(document.body);


  document.body.appendChild(topSentinel);
  document.body.appendChild(bottomSentinel);

  const banner = document.querySelector('.product-add-banner');

  let pastTop = false;
  let beforeBottom = true;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target === topSentinel) {
        pastTop = !entry.isIntersecting;
      }

      if (entry.target === bottomSentinel) {
        beforeBottom = !entry.isIntersecting;
      }
    });

    if (pastTop && beforeBottom) {
      banner.classList.add('visible');
    } else {
      banner.classList.remove('visible');
    }
  }, {
    root: null,
    threshold: 0
  });

  observer.observe(topSentinel);
  observer.observe(bottomSentinel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-main"]) return;
  try {
    
  // Create sentinels
  const topSentinel = document.createElement('div');
  const bottomSentinel = document.createElement('div');

  topSentinel.style.position = 'absolute';
  topSentinel.style.top = '100vh';
  topSentinel.style.height = '1px';

  bottomSentinel.style.position = 'absolute';
  bottomSentinel.style.height = '1px';
  bottomSentinel.style.width = '1px';

  const positionBottomSentinel = () => {
    bottomSentinel.style.top = `${
      document.documentElement.scrollHeight - window.innerHeight
    }px`;
  };

  positionBottomSentinel();

  const resizeObserver = new ResizeObserver(() => {
    positionBottomSentinel();
  });

  resizeObserver.observe(document.body);


  document.body.appendChild(topSentinel);
  document.body.appendChild(bottomSentinel);

  const banner = document.querySelector('.product-add-banner');

  let pastTop = false;
  let beforeBottom = true;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target === topSentinel) {
        pastTop = !entry.isIntersecting;
      }

      if (entry.target === bottomSentinel) {
        beforeBottom = !entry.isIntersecting;
      }
    });

    if (pastTop && beforeBottom) {
      banner.classList.add('visible');
    } else {
      banner.classList.remove('visible');
    }
  }, {
    root: null,
    threshold: 0
  });

  observer.observe(topSentinel);
  observer.observe(bottomSentinel);

  } catch(e) { console.error(e); }
})();
})();
